import React from 'react';
import HoverTooltip from '../HoverTooltip';
import InputWrapper from '../InputWrapper';
import ValidationMessage from '../ValidationMessage';
import Input from '../Input';
import TextArea from '../TextArea';
import { TextAreaProps } from '../TextArea/TextArea';
import { TypeProps, InputProps } from '../Input/Input';
import { InputLabelProps } from '../InputLabel/InputLabel';
import {
  ValidationMessageProps,
  ValidationState
} from '../ValidationMessage/ValidationMessage';
import { InputWrapperProps } from '../InputWrapper/InputWrapper';
import {
  HoverTooltipProps,
  HoverTooltipPositions
} from '../HoverTooltip/HoverTooltip';

interface TextInputProps extends React.HTMLAttributes<HTMLElement> {
  name?: string;
  id?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  label?: string;
  onBlur?: () => void;
  onChange?: React.FormEventHandler<HTMLInputElement>;
  placeholder?: string;
  textarea?: boolean;
  tooltipContent?: string;
  tooltipPosition?: HoverTooltipPositions;
  type?: TypeProps | 'textarea';
  validationMessage?: string;
  validationState?: ValidationState;
  value?: object;
  hoverTooltipProps?: HoverTooltipProps;
  inputLabelProps?: InputLabelProps;
  inputProps?: TextAreaProps | InputProps;
  validationProps?: ValidationMessageProps;
  wrapperProps?: InputWrapperProps;
}

const TEXTAREA = 'textarea';

const TextInput: React.FunctionComponent<TextInputProps> = ({
  hoverTooltipProps,
  id,
  inputLabelProps,
  inputProps,
  isDisabled = false,
  isRequired = false,
  label,
  name,
  onBlur,
  onChange,
  placeholder,
  tooltipContent,
  tooltipPosition,
  type,
  validationMessage,
  validationProps,
  validationState,
  value,
  wrapperProps
}) => {
  const InputElement = type === TEXTAREA ? TextArea : Input;

  return (
    <InputWrapper
      validationState={validationState}
      type={type}
      inputLabelProps={inputLabelProps}
      label={label}
      isRequired={isRequired}
      id={id}
      name={name}
      {...wrapperProps}
    >
      <HoverTooltip
        content={tooltipContent}
        position={tooltipPosition}
        {...hoverTooltipProps}
      >
        <InputElement
          name={id || name}
          type={type}
          disabled={isDisabled}
          required={isRequired}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          value={value}
          {...inputProps}
        />
      </HoverTooltip>
      <ValidationMessage validationState={validationState} {...validationProps}>
        {validationMessage}
      </ValidationMessage>
    </InputWrapper>
  );
};

export default TextInput;
